import React from 'react';
import { Icon } from './Icon.js';
export const IconBolt = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13 9H20V10L12 22H11V15H4V14L12 2H13V9Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));
};
//# sourceMappingURL=IconBolt.js.map